import { useState, useEffect } from 'react';
import apiClient from '../api/client';
import useAuthToken from './useAuthToken';

export const useWebhookUrl = () => {
  const [webhookUrl, setWebhookUrl] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = useAuthToken();

  useEffect(() => {
    const fetchUserInfo = async () => {
      if (!token) {
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        setError(null);

        // Try to get user info from token or make an API call
        // For now, we'll decode the JWT token to get clinic_id
        const payload = JSON.parse(atob(token.split('.')[1]));
        const clinicId = payload.clinic_id;
        
        if (clinicId) {
          const url = `https://medinsight.pro/api/webhooks/receive/${clinicId}`;
          setWebhookUrl(url);
        } else {
          setError('Unable to determine clinic ID');
        }
      } catch (err) {
        console.error('Error getting webhook URL:', err);
        setError('Failed to generate webhook URL');
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserInfo();
  }, [token]);

  const copyWebhookUrl = async () => {
    if (!webhookUrl) return false;
    
    try {
      await navigator.clipboard.writeText(webhookUrl);
      return true;
    } catch (err) {
      console.error('Failed to copy webhook URL:', err);
      return false;
    }
  };

  return {
    webhookUrl,
    isLoading,
    error,
    copyWebhookUrl,
  };
}; 